var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnboaring = function SvgOnboaring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "onboaring_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8A8 8 0 1 1 6.556.131l.374 2.037A5.929 5.929 0 1 0 13.929 8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1FC16B",
    strokeWidth: 4,
    d: "M16 8A8 8 0 1 1 6.556.131l.374 2.037A5.929 5.929 0 1 0 13.929 8z",
    mask: "url(#onboaring_svg__a)"
  })));
};
export default SvgOnboaring;